/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IOauthReposConnQueryVariables = Types.Exact<{
  integrationId: Types.Scalars['ID']['input'];
}>;

export type IOauthReposConnQuery = {
  __typename?: 'Query';
  oauthReposConn: {
    __typename?: 'OauthReposConn';
    repositories: Array<{ __typename?: 'OauthRepository'; id: string; name?: string | null; fullName?: string | null }>;
  };
};

export const OauthReposConnDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'oauthReposConn' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'integrationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'oauthReposConn' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'integrationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'integrationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'repositories' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IOauthReposConnQuery, IOauthReposConnQueryVariables>;
